<template>
    <article class="comment">

       <section class="comment-post" @click="getThreadComments(); showReplies();">
            <div class="comment-post__img">
                <img :src="comment.author_avatar_urls[24]" :alt="`User ${comment.author_name}`" />
            </div>
            <div class="comment-post__text">
                <cmscontent :content="`<span>${comment.author_name}</span>`"/>
                <cmscontent :content="`<small>${formatDate(comment.date)}</small>`"/>
                <cmscontent :content="`<p>${comment.content.rendered}</p>`" />
            </div>
            <div class="comment-post__replies">
                <div class="replies-length">
                    <i class="fas fa-comment-dots"></i>
                    <cmscontent :content="`<span>${replies.length}</span>`"/>
                </div>
                <div class="reply" @click="showCommentForm">
                    <i class="fas fa-reply"></i>
                    <span>Reply</span>
                </div>
            </div>
        </section>
        <div class="loading" v-show="hide">
            <loading-spinner :style="{ position: 'static' }"></loading-spinner>
        </div>

        <CommentHandler :comment="comment" :twoReplies="twoReplies" :showForm="showForm" :showThreadComments="showThreadComments" />
 
    </article>
</template>

<script>
import ThreadComments from './ThreadComments.vue';
import CommentForm from './CommentForm.vue';
import CommentHandler from './CommentHandler.vue';

export default {

    data() { 
        return {
            showForm: false,
            showThreadComments: false,
            hide: false,
            replies: [],
            twoReplies: [],
            loaded: true,
            addReply: {
                author_name: '',
                author_email: '',
                content: ''
            },
        }
    },
    props: {
        comment: Object
    },
    components: {
        ThreadComments,
        CommentForm,
        CommentHandler
    },
    mounted() {
      this.getCommentLength();
    },
    methods: {
        formatDate(date) {
            let options = { 
                day: 'numeric', 
                year: 'numeric', 
                month: 'long' 
            }

            let postDate = new Date(date);

            return postDate.toLocaleDateString('en-US', options);
        },
        showReplies() {
            this.showThreadComments = !this.showThreadComments;
        },
        showCommentForm() {
            this.showForm = !this.showForm;

            if (this.showThreadComments && this.showForm) {
                this.showReplies();
            }
            
        },
        getThreadComments() {
            const commentsDepth = this.$wpoptions.thread_comments_depth;
            const comment_order = this.$wpoptions.comment_order; 

            if (this.twoReplies.length === 0 && this.replies.length !== 0) {
                this.hide = true;
            } 
                
            this.$store.dispatch('getThreadComments', {  parent_exclude: 0, order: comment_order }).then(res => {
                
                let filteredData = res.data.filter(reply => reply.parent === this.comment.id);
                this.twoReplies = filteredData.slice(0, 2);
  
                this.$store.commit('setThreadComments', res.data);
                
                this.hide ? this.hide = !this.hide : this.hide;
          
            })
        },

        // TODO - Remove or find a better solution without request.
        getCommentLength() {

            this.$store.dispatch('getThreadComments', { parent_exclude: 0 }).then(res => {
                 
                let filteredData = res.data.filter(reply => reply.parent === this.comment.id);
                this.replies = filteredData;
            })
        },
  
    },

    watch: {
        showThreadComments: function() {
            this.getThreadComments();
        },
        showForm: function() {
            this.getCommentLength();
        },
        '$route' (to, from) {
            this.getThreadComments();
        }
    }


 
}
</script>

<style lang="scss">
@import '../../scss/settings';

    .comment {
        display: flex;
        flex-direction: column;
        margin-bottom: rem-calc(8);

        main {
            margin-left: auto;
            width: 90%;

            .form-section {
                margin: 0 1rem 1rem auto;
                max-width: rem-calc(300);
            }
        }
        

        @include medium-up {
            
        }

    }

    .comment-post {
        display: flex;
        flex-direction: row;
        padding: .5rem;

        &__text {
            display: flex;
            flex-direction: column;
            flex: 5;
            padding-left: rem-calc(6);
            justify-content: space-between;

            > .vuetenberg-wysiwyg-content span {
                font-weight: 700;
                margin: 0;
            }

            & :nth-child(2) {
                margin-top: rem-calc(-8);
                font-size: rem-calc(14);
            }
        }

        &__img {
            display: flex;
            align-items: flex-start;
            flex: 1;
            justify-content: center;
            padding-top: .5rem;

            img {
                border-radius: 9999rem;  
            }
        }

        &__replies {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;


            > .replies-length, .reply {
                flex-direction: row;
                @extend %center-content;

                .fas {
                    font-size: rem-calc(16);
                    margin: 0 .3rem;

                    &:hover {
                        cursor: pointer;
                    }
                }
            }

        }

        &__content {
            padding-top: rem-calc(16);
            padding-left: rem-calc(72);
        }

        &:hover {
            cursor: pointer;
        }

        @include medium-up {
            &__replies {
                min-width: rem-calc(90);
                width: rem-calc(90);
            }
        }

    }

</style>